import { PoolOptions } from "@quint/components";
import { Badge } from "@quint/ui";
import { isValidElement, useState } from "react";
import { useDebounce } from "use-debounce";
import Staking from "./staking";

import type { StakingCardDatum } from "./types";
export const Pool = ({
  pool: {
    name,
    apr,
    apy,
    currentlyStaked,
    totalHarvested,
    deprecated,
    address,
    unstakeButton,
    unstakeDialog,
    renderStakeButton,
    migrateButton,
  },
}: {
  pool: StakingCardDatum;
}) => {
  const [value, setValue] = useState<number | undefined>(0);
  const [debouncedValue] = useDebounce(value, 500);

  return (
    <>
      <div className="flex flex-col gap-y-6">
        <div className="hidden items-center justify-between xl:flex">
          <p>{name}</p>
          <PoolOptions address={address} />
        </div>
        <div className="flex flex-row justify-between gap-3 lg:pr-4">
          <p className="text-[16px] text-[#292929] opacity-70 dark:text-[#B3BAC0]">CURRENTLY STAKED</p>
          <p className="text-[#292929] dark:text-white">{currentlyStaked}</p>
        </div>
        <div className="flex flex-row justify-between gap-3 lg:pr-4">
          <p className="text-[16px] text-[#292929] opacity-70 dark:text-[#B3BAC0]">TOTAL HARVESTED</p>
          <p className="text-[#292929] dark:text-white">{totalHarvested}</p>
        </div>
        <div className="flex flex-row justify-between gap-3 lg:pr-4">
          <p className="text-[16px] text-[#292929] opacity-70 dark:text-[#B3BAC0]">APR</p>
          <p className="text-[#292929] dark:text-white">{apr}</p>
        </div>
        <div className="flex flex-row justify-between gap-3 lg:pr-4">
          <p className="text-[16px] text-[#292929] opacity-70 dark:text-[#B3BAC0]">APY</p>
          <p className="text-[#292929] dark:text-white">{apy}</p>
        </div>
      </div>
      <div>
        {/* divider */}
        {deprecated ? <div className="my-8 h-[1px] w-full bg-[#E6E8EA] dark:bg-[#354856]" /> : <div className="mt-8" />}
        {/* field, or migration text */}
        <div className="mb-6 px-1">
          {deprecated ? (
            <>
              <p>We&apos;ve migrated to an upgraded staking pool! Please:</p>
              <p>1- Migrate Rewards</p>
              <p>2- Unstake</p>
              <p>3- Stake in Quint V2</p>
            </>
          ) : (
            <Staking.TokensInput value={value} setValue={setValue} />
          )}
        </div>
        {/* two buttons */}
        <div className="flex flex-col gap-6 md:flex-row">
          {deprecated ? (
            <>
              <Badge content="1" className="w-full">
                {isValidElement(migrateButton) ? migrateButton : null}
              </Badge>
              <Badge content="2" className="w-full">
                {isValidElement(unstakeButton) ? unstakeButton : null}
              </Badge>
            </>
          ) : (
            <>
              {renderStakeButton?.(debouncedValue || 0, setValue)}
              {isValidElement(unstakeDialog) ? unstakeDialog : null}
            </>
          )}
        </div>
      </div>
    </>
  );
};
